export class AxButton {
    Loading(btn: HTMLElement) {
        let $btn = $(btn);
        if (!$btn.hasClass("ax-loading")) {
            $btn.prop("disabled", true).addClass('ax-loading').append("<span class='ax-btn-loading'></span>");
        }
    }

    StopLoading(btn: HTMLElement) {
        let $btn = $(btn);
        if ($btn.hasClass("ax-loading")) {
            $btn.prop("disabled", false).removeClass('ax-loading');
            $btn.find('.ax-btn-loading').remove();
        }
    }
}